import { render, staticRenderFns } from "./AddUpdateScreenshot.vue?vue&type=template&id=b4f962e6"
import script from "./AddUpdateScreenshot.vue?vue&type=script&lang=js"
export * from "./AddUpdateScreenshot.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateScreenshot.vue?vue&type=style&index=0&id=b4f962e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports